/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Row_DoneInputs */

const vi_shop_home_row_done = /** @type {(inputs: Shop_Home_Row_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xong`)
};

/**

* @param {Shop_Home_Row_DoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_done = /** @type {((inputs?: Shop_Home_Row_DoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_DoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_done(inputs)
});